<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "Report3D",
        icon: require("@/assets/images/digitalImg/report3d_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/report3d_icon.png"),
          title: "Report3D – Informed Decisions, Creativity First!",
          subTitle:
            "A 3D solution reporting tool, easily build 3D scenes and report solutions.",
          downloadBtnList: [
            {
              label: "Download",
              fileUrl: "",
              fileName: "Report3D",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_report3d.png"),
          videoUrl: `${prefix}/static/video/report3d_en.mp4`,
        },
        all: {
          title: "What is Report3D？",
          content:
            "Report3D is a digital reporting system developed based on a game engine, designed for a wide range of engineering applications. It allows for the efficient creation of real-time rendered scenes and PowerPoint presentations, enabling users to view and interact with digital twin models. No complex installation or configuration is required, lowering the threshold for using 3D scenes and making it easier for more people to participate in building 3D scenes and preparing PPT reports.",
          imgLists: [
            {
              id: 1,
              title: "Multi source model fusion（1/3）",
              img: require("@/assets/images/digitalImg/report3d_img1.png"),
            },
            {
              id: 2,
              title: "Tilt photography data support（2/3） ",
              img: require("@/assets/images/digitalImg/report3d_img2.png"),
            },
            {
              id: 3,
              title: "Rich model library and material library（3/3）",
              img: require("@/assets/images/digitalImg/report3d_img3.png"),
            },
          ],
        },
        highlights: {
          title: "Why Choose Report3D？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/report3d_icon1.png"),
              title: "Efficient 3D Reportin",
              content:
                "The software dynamically displays complex 3D spatial relationships, accurately conveying design and construction intentions. ",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/report3d_icon2.png"),
              title: "Integrated 2D and 3D Reporting ",
              content:
                "The software not only inherits the interactive nature of traditional PowerPoint but also enhances presentation content with high-quality visual effects powered by real-time rendering engines. ",
            },
          ],
        },

        function: {
          title: "Report3D Functions",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/report3d_function01.png"),
              title: "Multi-source Data Integration",
              content:
                "Supports importing model data from mainstream modeling software like Revit, Bentley, 3DS Max, etc. It seamlessly integrates with the data from Delauney’s self-developed EICAD and AIRoad, allowing the import of BIM models along with route horizontal and vertical design information. This deepens the application value of the 3D model and forms the foundation for digital reporting scene construction.",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/report3d_function02.png"),
              title: "Support for Large-scale Oblique Photography Data",
              content:
                "Capable of smoothly loading 200GB of oblique photography models. It includes an oblique photography transparency tool, enabling users to customize the cutting areas. The software automatically hides data within the selected area, facilitating the seamless integration of oblique photography and engineering models.",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/report3d_function03.png"),
              title: "Rich Model and Material Libraries",
              content: [
                "Utilizes the model library to quickly place models by dragging them along a path, reducing the workload of users when constructing scenes. The software includes a material library that allows users to swap materials by dragging material spheres, experimenting with different combinations to achieve better presentation effects.",
              ],
            },
            {
              id: 4,
              img: require("@/assets/images/digitalImg/report3d_function04.png"),
              title: "Diverse Marking Styles",
              content:
                "The software comes with a variety of 3D marking styles for points, lines, and surfaces. Users can emphasize key points and information by using these diverse marking styles, making design intentions easier to explain and understand. It also supports batch importing of CAD marking data, significantly improving marking efficiency.",
            },
            {
              id: 5,
              img: require("@/assets/images/digitalImg/report3d_function05.png"),
              title: "3D PPT Creation",
              content: [
                "Adopts a PPT + 3D digital display approach for presentations. The 2D editing functions follow traditional PPT editing operations. Existing PPT files can be imported with a single click to add 3D display content. Presenters can set 3D viewpoints and roaming paths for the presentation in advance, ensuring a quick and easy 3D report creation process. During the presentation, no complicated operations are required to deliver smooth, coherent, and intuitive design expression. The interactive 2D and 3D functionality makes the report more intuitive and enables the audience to grasp the content more quickly.",
              ],
            },
          ],
        },
        support: {
          title: "Report3D User Support",
          documnentUrl: "/download?type=manual",
          videosUrl: "/academy?type=Report3D",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/report3d_contactbg.png"),
          title: "Get Report3D Now!",
          subTitle:
            "Delauney Digital Design Software Line offers a one-stop design solution.",
          firstBtnText: "Download Software",
          firstBtnUrl: "",
          secondBtnText: "Contact Sales Representative",
          secondBtnUrl: "",
        },
        combination: {
          title:
            "Enhance your workflow by integrating VRRoad with other software.",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/report3d_combination01.png"),
              title:
                "The project used AIRoad for route design and Report3D for traffic diversion scenario and traffic flow layout, enabling real-time viewing of diversion plans and delivering clear and intuitive presentations.",
              subTitle: "",
              content:
                "Implementation Plan Presentation for Hu-Wu Expressway Reconstruction and Expansion using Report3D + AIRoad",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/airoad_icon3.png"),
              desc: "Photogrammetry, and remote sensing data. It enables dynamic interactive routing and automated scheme modeling.",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "4" }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
